import React from "react";
import "./FooterSite.css";
import { useNavigate, NavLink, Navigate, useLocation } from "react-router-dom";
const MiniFooterSite = () => {
    const navigate = useNavigate();
    return (
        <footer className="footerClass" align="center">
        
        <div class="row">
            <div class="col">
                <img align="center"  src="./footer.png"/>
                <img align="right" width="55px" src="./icon-chat-footer.png" onClick={()=>{navigate("/chat")}}/>

                </div>
        </div>
   </footer>
    

    );
}

export default MiniFooterSite;